module.exports = __webpack_public_path__ + "media/images/ShiftPredict-illustration-5d4e43e23d72f519d43a3ee7f3034be6.png";